(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

    document.querySelectorAll('[data-desktop-filter-toggle]').forEach((button) => {
      const controlsId = button.getAttribute('aria-controls');
      const panel = controlsId ? document.getElementById(controlsId) : null;
      const wrapper = button.closest('.collection-wrapper');
      if (!panel || !wrapper) return;

      const setState = (open) => {
        wrapper.classList.toggle('facets-sidebar-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        const icon = button.querySelector('.facets-desktop-filter-toggle__icon');
        if (icon) icon.textContent = open ? '-' : '+';
      };

      setState(false);

      button.addEventListener('click', () => {
        if (!isDesktop()) return;
        setState(!wrapper.classList.contains('facets-sidebar-open'));
      });

      window.addEventListener('resize', () => {
        if (!isDesktop()) {
          setState(false);
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
